module.exports = __webpack_public_path__ + "img/logo-color-set.f7dce4df.svg";